var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHonduras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4541C24.8366 32.4541 32 25.2907 32 16.4541C32 7.61755 24.8366 0.454102 16 0.454102C7.16344 0.454102 0 7.61755 0 16.4541C0 25.2907 7.16344 32.4541 16 32.4541Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32.4544C22.3435 32.4544 27.8245 28.7628 30.4125 23.4109H1.58777C4.17577 28.7628 9.65677 32.4544 16.0001 32.4544Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.454102C9.65677 0.454102 4.17577 4.14566 1.58777 9.4976H30.4125C27.8245 4.14566 22.3435 0.454102 16.0001 0.454102V0.454102Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84647 10.8889L10.3645 12.4832H12.0408L10.6847 13.4684L11.2027 15.0628L9.84647 14.0774L8.49022 15.0628L9.00829 13.4684L7.6521 12.4832H9.32841L9.84647 10.8889Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84647 17.8456L10.3645 19.44H12.0408L10.6847 20.4253L11.2027 22.0195L9.84647 21.0342L8.49022 22.0195L9.00829 20.4253L7.6521 19.44H9.32841L9.84647 17.8456Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1537 10.8889L22.6718 12.4832H24.3481L22.9919 13.4684L23.51 15.0628L22.1537 14.0774L20.7975 15.0628L21.3155 13.4684L19.9594 12.4832H21.6357L22.1537 10.8889Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1537 17.8456L22.6718 19.44H24.3481L22.9919 20.4253L23.51 22.0195L22.1537 21.0342L20.7975 22.0195L21.3155 20.4253L19.9594 19.44H21.6357L22.1537 17.8456Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 14.3668L16.5184 15.9612H18.1947L16.8385 16.9464L17.3565 18.5407L16.0003 17.5554L14.644 18.5407L15.1621 16.9464L13.8059 15.9612H15.4822L16.0003 14.3668Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonduras);
export default __webpack_public_path__ + "static/media/honduras.dccb9958.svg";
export { ForwardRef as ReactComponent };